/* Indonesian (Bahasa Indonesia) dictionary.
 * Keys are the exact English strings used in the UI; values are the translations.
 * Split by area so several people (or tools) can work without merge conflicts.
 * Later chunks win on duplicate keys — keep shared vocabulary in common.js. */
import common from './common';
import shell from './shell';
import ui from './ui';
import suppliers from './suppliers';
import catalog from './catalog';
import requisitions from './requisitions';
import marketlist from './marketlist';
import purchaseOrders from './purchase-orders';
import inventory from './inventory';
import finance from './finance';
import users from './users';
import settings from './settings';
import misc from './misc';

const id = {
  ...common,
  ...ui,
  ...shell,
  ...suppliers,
  ...catalog,
  ...requisitions,
  ...marketlist,
  ...purchaseOrders,
  ...inventory,
  ...finance,
  ...users,
  ...settings,
  ...misc,
};

export default id;
